/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_File_PreviewInputs */

const cs_chat_file_preview = /** @type {(inputs: Chat_File_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled`)
};

const en_chat_file_preview = /** @type {(inputs: Chat_File_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Chat_File_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_file_preview = /** @type {((inputs?: Chat_File_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_File_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_file_preview(inputs)
	return cs_chat_file_preview(inputs)
});